import { type FC } from "react"

import { type CommunityPostReaction } from "@forento/core/models/community"
import CommunityPostReactionList from "@forento/ui/components/CommunityPostReactionList"

import { DefaultModal, ModalButtons, ModalContentPadding, ModalTitle } from "~/components/Modal"

import Button from "./Button"
import PartialLoadingPage from "./PartialLoadingPage"

type Props = {
	reactions: CommunityPostReaction[] | undefined
	hasError?: boolean
	isOpen: boolean
	onClose(): void
}
const ReactionsModal: FC<Props> = ({ reactions, hasError = false, isOpen, onClose }) => (
	<DefaultModal onClose={onClose} isOpen={isOpen}>
		<ModalTitle>Reactions</ModalTitle>
		<ModalContentPadding>
			{hasError ? (
				<p>Failed to load reactions.</p>
			) : reactions === undefined ? (
				<PartialLoadingPage />
			) : (
				<CommunityPostReactionList reactions={reactions} />
			)}
		</ModalContentPadding>
		<ModalButtons>
			<Button variant="primary" onClick={onClose}>
				Close
			</Button>
		</ModalButtons>
	</DefaultModal>
)

export default ReactionsModal
